import { retrieveMatterSettingsV2 } from "@/lib/data/requests/matters/matter-settings";
import { queryKeys } from "@/lib/data/static/query-keys";

export const retrieveMatterSettingsQueryOptions = () => {
  return {
    queryKey: [queryKeys.matterSettings],
    queryFn: () => retrieveMatterSettingsV2(),
  };
};
